<template>
  <div>
    <HelloWorld msg="Business App"/>
  </div>
</template>
<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
    HelloWorld
  },
  data() {
    return {}
  }
}
</script>
<style>
body {
  background-color: snow;
}
</style>
